import { useEffect, useState, useContext } from 'react';
import { default as axios } from '../axiosConfig';
import UserContext from '../Contexts/UserContext';
import { API_DeleteUser, API_GetActiveUsers, API_LockUser, API_UnlockUser } from '../Assets/ApiUrlContainer';

const LockedUsers = () => {
	const [users, setUsers] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const { user } = useContext(UserContext);

	useEffect(() => {
		fetchUsers();
		// eslint-disable-next-line
	}, []);

	const fetchUsers = async () => {
		try {
			const response = await axios.get(API_GetActiveUsers, { 
				withCredentials: true,
				headers: { 'Content-Type': 'application/json' },
			});

			console.log('Fetched Users:', response.data);

			let filteredUsers = response.data.map(u => ({
				...u,
				FirstName: u.FirstName || "",
				LastName: u.LastName || "",
				Email: u.Email || "",
				Role: u.Role || "",
				Locked: u.Locked,
				Id: u.Id
			})).filter(
				(fetchedUser) =>
					(fetchedUser.Email || '').toLowerCase() !== (user.Email || '').toLowerCase() &&
					(fetchedUser.Role || '').toLowerCase() !== 'admin'
			);

			// Sort so locked users appear first
			filteredUsers.sort((a, b) => (b.Locked ? 1 : 0) - (a.Locked ? 1 : 0));

			setUsers(filteredUsers);
		} catch (error) {
			console.error('Error fetching users:', error);
		}
	};

	const handleAction = async (email, action) => {
		let endpoint = '';
		if (action === 'lock') endpoint = API_LockUser;
		if (action === 'unlock') endpoint = API_UnlockUser;
		if (action === 'delete') endpoint = API_DeleteUser;

		setLoading(true);
		try {
			const response = await axios.post(endpoint, { email }, {
				withCredentials: true,
				headers: { 'Content-Type': 'application/json' },
			});

			console.log(`${action} Response:`, response.data);
			fetchUsers(); // Refresh list after action
		} catch (error) {
			console.error(`Error performing ${action} action:`, error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
			<h2 style={{ textAlign: 'center' }}>User Management (Lock, Unlock, Delete)</h2>

			{/* Search Field */}
			<input
				type='text'
				placeholder='Search by name or email...'
				value={searchTerm}
				onChange={(e) => setSearchTerm(e.target.value)}
				style={{
					width: '100%',
					padding: '10px',
					marginBottom: '15px',
					borderRadius: '5px',
					border: '1px solid #ddd',
				}}
			/>

			{/* Refresh Button */}
			<button
				onClick={fetchUsers}
				style={{
					marginBottom: '15px',
					padding: '10px 16px',
					cursor: 'pointer',
					backgroundColor: '#3498db',
					color: 'white',
					border: 'none',
					borderRadius: '5px',
					fontSize: '14px',
				}}
			>
				🔄 Refresh List
			</button>

			<table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
				<thead>
					<tr style={{ backgroundColor: '#f2f2f2', textAlign: 'left' }}>
						<th style={{ padding: '10px' }}>First Name</th>
						<th style={{ padding: '10px' }}>Last Name</th>
						<th style={{ padding: '10px' }}>Email</th>
						<th style={{ padding: '10px' }}>Role</th>
						<th style={{ padding: '10px' }}>Status</th>
						<th style={{ padding: '10px' }}>Actions</th>
					</tr>
				</thead>
				<tbody>
					{users
						.filter(
							(user) =>
								(user.FirstName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
								(user.LastName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
								(user.Email || '').toLowerCase().includes(searchTerm.toLowerCase())
						)
						.map((user) => (
							<tr key={user.Id} style={{ borderBottom: '1px solid #ddd' }}>
								<td style={{ padding: '10px' }}>{user.FirstName || 'N/A'}</td>
								<td style={{ padding: '10px' }}>{user.LastName || 'N/A'}</td>
								<td style={{ padding: '10px' }}>{user.Email || 'N/A'}</td>
								<td style={{ padding: '10px' }}>{user.Role || 'N/A'}</td>
								<td
									style={{
										padding: '10px',
										fontWeight: 'bold',
										color: user.Locked ? 'red' : 'green',
									}}
								>
									{user.Locked ? 'Locked' : 'Active'}
								</td>

								<td style={{ padding: '10px' }}>
									{/* Conditionally show Lock or Unlock button */}
									{user.Locked ? (
										<button
											disabled={loading}
											onClick={() => handleAction(user.Email, 'unlock')}
											style={{
												marginRight: '5px',
												padding: '8px',
												backgroundColor: 'green',
												color: 'white',
												border: 'none',
												borderRadius: '5px',
												cursor: 'pointer',
											}}
										>
											Unlock
										</button>
									) : (
										<button
											disabled={loading}
											onClick={() => handleAction(user.Email, 'lock')}
											style={{
												marginRight: '5px',
												padding: '8px',
												backgroundColor: 'orange',
												color: 'white',
												border: 'none',
												borderRadius: '5px',
												cursor: 'pointer',
											}}
										>
											Lock
										</button>
									)}

									{/* Delete Button */}
									<button
										disabled={loading}
										onClick={() => handleAction(user.Email, 'delete')}
										style={{
											padding: '8px',
											backgroundColor: 'red',
											color: 'white',
											border: 'none',
											borderRadius: '5px',
											cursor: 'pointer',
										}}
									>
										Delete
									</button>
								</td>
							</tr>
						))}
				</tbody>
			</table>
		</div>
	);
};

export default LockedUsers;